import { render, staticRenderFns } from "./mainContent.vue?vue&type=template&id=0e2d0709&scoped=true"
import script from "./mainContent.vue?vue&type=script&lang=js"
export * from "./mainContent.vue?vue&type=script&lang=js"
import style0 from "./mainContent.vue?vue&type=style&index=0&id=0e2d0709&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d0709",
  null
  
)

export default component.exports